export interface ICustomElement {

    visible: boolean;
    enabled: boolean;
    readonly isAttached: boolean;

    //#region Zpracování metod z globální třídy GenericControl

    /**
     * Zaregistruje událost
     * @param event Název události
     * @param listener Akce při vyvolání události
     * @param customId Volitelný vlastní identifikátor listeneru
     */
    registerEventListener(event: string, listener: EventListener, customId?: string): void;

    /**
     * Odregistruje udalost. Pokud neni vyplnen zadny parametr, jsou odregistrovany vsechny udalosti. Pokud je vyplnen pouze event, odregistruje vsechny udalosti daneho typu
     * pokud je vyplnen event a action, odregistruje pouze konkretni akci
     * @param event Event, ktery chcete odregistrovat.
     * @param listener Akce, ktere se tyka event a chcete ji odregistrovat
     */
    unregisterEventListener(event?: string, listener?: EventListener): void;

    /**
     * Vyvolá událost na elementu
     * @param eventName Název události
     * @param detail Podrobnosti události
     * @param bubbles Zda má událost probublávat DOMem nebo ne
     * @param cancelable Zda může být událost zrušena a zda může být voláno preventDefault()
     * @return Vrátí CustomEvent
     */
    callEvent(eventName: string, detail?: any, bubbles?: boolean, cancelable?: boolean): CustomEvent;

    //#endregion Zpracování metod z globální třídy GenericControl
}
